/**
 * Mapping des wordings pour l'affichage des animaux acceptés.
 * Les libellés passent par le service de traduction (clés : animalsAccepted, animalsAcceptedWithSupplement, etc.).
 * Conditions :
 * - ACCEPTES + NON_DISPONIBLE → animalsAccepted
 * - ACCEPTES + AVEC_SUPPLEMENT → animalsAcceptedWithSupplement
 * - ACCEPTES + SANS_SUPPLEMENT → animalsAcceptedWithoutSupplement
 * - NON_ACCEPTES + NON_DISPONIBLE → animalsNotAccepted
 * - NON_DISPONIBLE + NON_DISPONIBLE → champ masqué (géré dans renderRoomsAndAnimalsSection / bloc Animaux)
 */
export const ANIMAUX_WORDING_KEYS = {
  ACCEPTES: {
    AVEC_SUPPLEMENT: "animalsAcceptedWithSupplement",
    SANS_SUPPLEMENT: "animalsAcceptedWithoutSupplement",
    default: "animalsAccepted",
  },
  NON_ACCEPTES: {
    default: "animalsNotAccepted",
  },
} as const;

/**
 * Retourne la clé de traduction pour le wording des animaux acceptés.
 * @param animauxAcceptes - "ACCEPTES" | "NON_ACCEPTES"
 * @param supplement - "AVEC_SUPPLEMENT" | "SANS_SUPPLEMENT" | "NON_DISPONIBLE" | undefined
 */
export function getAnimalWordingKey(
  animauxAcceptes: "ACCEPTES" | "NON_ACCEPTES",
  supplement?: string | null,
): string {
  if (animauxAcceptes === "ACCEPTES") {
    const keyMap = ANIMAUX_WORDING_KEYS.ACCEPTES;
    if (supplement === "AVEC_SUPPLEMENT") return keyMap.AVEC_SUPPLEMENT;
    if (supplement === "SANS_SUPPLEMENT") return keyMap.SANS_SUPPLEMENT;
    return keyMap.default;
  }
  return ANIMAUX_WORDING_KEYS.NON_ACCEPTES.default;
}

/**
 * Retourne le wording traduit pour l'affichage des animaux acceptés.
 * @param t - Fonction de traduction (key) => string
 */
export function getAnimalWording(
  animauxAcceptes: "ACCEPTES" | "NON_ACCEPTES",
  supplement: string | null | undefined,
  t: (key: string) => string,
): string {
  return t(getAnimalWordingKey(animauxAcceptes, supplement));
}
